// CompositionPlanBlock — the editable outline the composer produced before
// drafting. The "two-stage collaboration" lens: the reviewer can see the
// plan the agent followed, not just the finished body.

interface CompositionPlanBlockProps {
    plan: string[];
}

export default function CompositionPlanBlock({ plan }: CompositionPlanBlockProps) {
    return (
        <div
            data-testid="workbench-composition-plan"
            className="rounded-md border border-[rgb(var(--color-divider))] bg-[rgb(var(--color-surface-secondary)/0.4)] p-3"
        >
            <div className="text-card-title text-[rgb(var(--color-text-primary))] mb-2">
                Composition plan
            </div>
            <ol className="list-decimal ml-5 flex flex-col gap-1">
                {plan.map((step, i) => (
                    <li key={i} className="text-annotation text-[rgb(var(--color-text-primary))]">
                        {step}
                    </li>
                ))}
            </ol>
        </div>
    );
}
